/**
 *
 * Asynchronously loads the component for ClassSetup
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const ClassSetup = lazyLoad(
  () => import('./index'),
  module => module.ClassSetup,
);
